export default "__VITE_ASSET__V6B1oFw6__"